import { cn } from '@/libs/utils';
import { ContentBody, ContentHeader, ContentWrapper } from '../content';

export default function DataTableSkeleton({
  title,
  className,
  columnLength = 4,
}) {
  return (
    <ContentWrapper className={cn('rounded-none border-0', className)}>
      {title && (
        <ContentHeader title={title}>
          <div className="h-8 w-24" />
        </ContentHeader>
      )}

      <ContentBody>
        <div className="with-y-overflow--skeleton">
          <div className="divide-y divide-zinc-100">
            {Array.from({ length: columnLength }).map((_, idx) => {
              return (
                <div
                  key={idx}
                  className={cn(
                    'flex h-[55px] w-full items-center justify-center gap-2 px-6 md:gap-4 lg:gap-6',
                    idx === 0 ? 'bg-zinc-100' : 'bg-white'
                  )}
                >
                  {Array.from({ length: columnLength }).map((_, index) => {
                    const colIndex = index + 1;
                    const isFirstChild = colIndex === 1;
                    const isLastChild = colIndex === columnLength;

                    return (
                      <div
                        key={index}
                        className={cn(
                          'h-6 w-1/2 rounded-[20px] shadow-sm',
                          idx === 0 ? 'bg-white' : 'animate-pulse bg-zinc-100',
                          isFirstChild
                            ? idx !== 0
                              ? 'w-6 shrink-0 rounded bg-zinc-100'
                              : 'w-6 shrink-0 rounded'
                            : '',
                          isLastChild
                            ? idx !== 0
                              ? 'h-8 w-8 rounded bg-zinc-100'
                              : 'h-8 w-8 rounded'
                            : ''
                        )}
                      />
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </ContentBody>
    </ContentWrapper>
  );
}
